import { resolveStoredFileUrl } from "utils/storedFileUrl";
// React
import { useContext, useEffect, useMemo, useState } from "react";

import PropTypes from "prop-types";

// Components
import { Card, Divider, Grid, Icon, Input, Paper, Table, TableBody, TableContainer, TableHead, TableRow, TableCell, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import ModalLicitacionProducto from "./ModalLicitacionProducto";
import SoftButton from "components/SoftButton";
import { gql, useMutation, useQuery } from "@apollo/client";
import { MessageManager } from "context";
import { formatMoneyPunto } from "utils/formatters";
import { ConfirmarContext } from "context/ConfirmarContext";
import SoftBadge from "components/SoftBadge";
import dayjs from "dayjs";
import aprobadosData from "../data/aprobadosData";
import { makeNiceText } from "utils/formatters";
import FilaProducto from "../data/filaProducto";
import { calcularTotalOfertado } from "../data/cotizacionOferta";
import PDFPliego from "assets/PDF/Bases_y_Condiciones_de_Compra.pdf";
import { nombreCompraDetalle } from "utils/presentacionCompra";
function ListadoProductos({ detalles, setSelected, idProveedor, refetchParent, colores }) {
  const { handleSnackbar } = useContext(MessageManager);
  const { confirmar } = useContext(ConfirmarContext);
  const [productoElegido, setProductoElegido] = useState(null);
  const [productos, setProductos] = useState([]);
  const [provision, setProvision] = useState(null);
  const total = useMemo(() => calcularTotalOfertado(productos), [productos]);
  const { columns: columnsAprobados, getRows: getRowsAprobados } = aprobadosData;
  const [rows, setRows] = useState([]);
  const [rowsAprobados, setRowsAprobados] = useState([]);
  const [keyFile, setKeyFile] = useState(0);
  const [file, setFile] = useState(null);
  const [adjuntos, setAdjuntos] = useState([]);
  const [pliegos, setPliegos] = useState(null);
  const [cambiosNoGuardados, setCambiosNoGuardados] = useState(false);
  const [periodoVigente, setPeriodoVigente] = useState(false);
  const licitacionHabilitada = detalles?.puedeCotizar === true && periodoVigente;
  useEffect(() => {
    const cierre = dayjs(detalles?.licitacionFin).valueOf();
    const restante = cierre - Date.now();
    setPeriodoVigente(Boolean(detalles?.licitacionFin) && restante > 0);
    if (!Number.isFinite(restante) || restante <= 0) return undefined;
    const timer = setTimeout(() => setPeriodoVigente(false), Math.min(restante, 2147483647));
    return () => clearTimeout(timer);
  }, [detalles?.licitacionFin]);
  const indexActual = productoElegido && Array.isArray(productos) ? productos.findIndex((p) => p.id === productoElegido.id) : -1;
  const productoAnterior = indexActual > 0 ? productos[indexActual - 1] : null;

  const { data: dataEstados } = useQuery(
    gql`
      query pedidoEstadosListadoProductos($idPedido: ID!) {
        pedidoCompraEstados(id: $idPedido) {
          id
          file
          cancelado
          base {
            nombre
          }
        }
      }
    `,
    {
      variables: {
        idPedido: detalles.id,
      },
      skip: !detalles,
    }
  );

  useEffect(() => {
    if (dataEstados) {
      const estados = dataEstados?.pedidoCompraEstados?.filter((i) => !i.cancelado);

      const general = estados?.find(
        (item) => item.base.nombre.toUpperCase().includes("PLIEGO") && item.base.nombre.toUpperCase().includes("GENERAL")
      );
      const particular = estados?.find(
        (item) => item.base.nombre.toUpperCase().includes("PLIEGO") && item.base.nombre.toUpperCase().includes("PARTICULAR")
      );
      const solicitud = estados?.find((item) => item.base.nombre.toUpperCase().includes("SOLICITUD DE GASTOS"));
      const ranking = estados?.find((item) => item.base.nombre.toUpperCase().includes("RANKING"));

      // Obtener los demás archivos que no son pliegos, solicitud ni ranking
      const otrosAdjuntos = estados?.reduce((acc, item) => {
        if (item.file && item.file.length > 0) {
          const nombreBase = item.base.nombre.toUpperCase();
          const esSolicitud = nombreBase.includes("SOLICITUD DE GASTOS");

          if (esSolicitud) {
            acc.push(
              ...item.file.map((file) => ({
                nombre: file.split("\\").pop(),
                url: file,
              }))
            );
          }
        }
        return acc;
      }, []);
      // Guardar pliegos
      setPliegos({
        general: general?.file?.[0] ? resolveStoredFileUrl(general.file[0]) : `/pliego-general/pdf/${detalles.id}`,
        particular: particular?.file?.[0] ? resolveStoredFileUrl(particular.file[0]) : `/pliego-particular/pdf/${detalles.id}`,
        solicitud: solicitud?.file?.[0] ? resolveStoredFileUrl(solicitud.file[0]) : `/solicitud/pdf/${detalles.id}`,
        ranking: ranking?.file?.[0] ? resolveStoredFileUrl(ranking.file[0]) : `/ranking-proceso-contratacion/pdf/${detalles.id}`,
      });

      // Guardar otros adjuntos
      setAdjuntos(otrosAdjuntos || []);
    }
  }, [dataEstados]);

  const [mutate, { loading: loadingMutation }] = useMutation(
    gql`
      mutation saveCotizacion($input: CotizacionInput!) {
        saveCotizacion(input: $input) {
          id
        }
      }
    `,
    {
      onCompleted: () => {
        handleSnackbar("Cambios guardados", "success");
      },
      onError: (error) => {
        handleSnackbar(error.message || "No se pudo guardar la cotización", "error");
      },
    }
  );

  useEffect(() => {
    if (detalles) {
      if (detalles?.cotizaciones?.find((item) => String(item.idProveedor) === String(idProveedor))) {
        let arrayDetalles = detalles.detalles;
        let cotizacionesProveedor = detalles.cotizaciones?.filter((item) => item.idProveedor == idProveedor)[0];
        arrayDetalles = arrayDetalles.map((detalle) => {
          let arrayCotizaciones = cotizacionesProveedor.detalles.filter((item) => item.idPedidoCompraDetalle === detalle.id);
          return {
            ...detalle,
            cotizaciones: arrayCotizaciones,
            opcion: 1,
          };
        });
        setProductos(arrayDetalles);
        if (cotizacionesProveedor.file) {
          setFile({
            name: cotizacionesProveedor?.file?.split("\\").pop(),
            url: cotizacionesProveedor.file,
            saved: true,
          });
        }
      } else {
        let arrayDetalles = detalles.detalles.map((detalle) => ({
          ...detalle,
          opcion: 2,
        }));
        setProductos(arrayDetalles);
      }
      setCambiosNoGuardados(false);

      if (detalles?.provisiones?.length > 0) {
        const prov = detalles.provisiones.find((item) => item.proveedor.id === idProveedor && !item.anulada);
        setProvision(prov);
      } else {
        setProvision(null);
      }
    }
  }, [detalles, idProveedor]);

  useEffect(() => {
    setRows(productos);
  }, [productos]);

  useEffect(() => {
    if (provision) {
      setRowsAprobados(getRowsAprobados(provision.detalles.map((item) => ({
        ...item,
        pedidoCompraDetalle: detalles.detalles?.find((detalle) => String(detalle.id) === String(item.idPedidoCompraDetalle)),
      }))));
    }
  }, [provision, detalles]);


  const handleChangeOferta = (producto) => {
    if (!licitacionHabilitada) return;
    setProductos((anteriores) => anteriores.map((solicitado) => {
      if (String(solicitado.id) !== String(producto.id)) return solicitado;
      const ofertas = [...(solicitado.cotizaciones || [])];
      const alternativo = !solicitado.requierePack && Boolean(producto.alternativo);
      const nombreAlternativo = alternativo ? String(producto.nombreAlternativo || "").trim() : null;
      const indice = producto.indexEdit ?? ofertas.findIndex((oferta) =>
        Boolean(oferta.materiaPrimaAlternativo) === alternativo &&
        (!alternativo || String(oferta.nombreAlternativo || "").trim().toLocaleLowerCase("es") === nombreAlternativo.toLocaleLowerCase("es"))
      );
      const oferta = {
        idPedidoCompraDetalle: solicitado.id,
        idMateriaPrima: solicitado.materiaPrima?.id ?? null,
        materiaPrimaAlternativo: alternativo,
        nombreAlternativo,
        precio: Number(producto.precio),
        plazoEntrega: Number(producto.plazoEntrega),
        observacion: producto.observacion,
        nombre: solicitado.materiaPrima?.nombre || solicitado.nombreServicio,
        nombreCompra: nombreCompraDetalle(solicitado),
        requierePack: Boolean(solicitado.requierePack),
        unidadPack: solicitado.unidadPack,
        unidad: solicitado.requierePack ? solicitado.unidadPack : solicitado.unidadNombre || solicitado.materiaPrima?.tipoUnidad?.nombre,
      };
      if (indice >= 0) ofertas[indice] = oferta;
      else ofertas.push(oferta);
      return { ...solicitado, cotizaciones: ofertas, opcion: 2 };
    }));
    setProductoElegido(null);
    setCambiosNoGuardados(true);
  };
  const handleChangeProducto = handleChangeOferta;
  const handleChangeServicio = handleChangeOferta;

  const removeLicitacion = (index, idProducto) => {
    let newProductos = [...productos];
    let producto = newProductos.find((item) => item.id === idProducto);
    if (!licitacionHabilitada) return;
    let arrayCotizaciones = producto.cotizaciones.filter((oferta, indice) => indice !== index);
    setCambiosNoGuardados(true);
    newProductos[newProductos.findIndex((item) => item.id === idProducto)] = {
      ...producto,
      cotizaciones: arrayCotizaciones,
      opcion: 3,
    };
    setProductos(newProductos);
  };
  const toggleInput = () => {
    document.getElementById("input-file").click();
  };
  const handleFile = (e) => {
    setKeyFile(keyFile + 1);
    setFile(e.target.files[0]);
    setCambiosNoGuardados(true);
  };
  const handleSaveLicitacion = () => {
    if (!licitacionHabilitada || loadingMutation) return;
    confirmar({
      title: "Guardar cambios",
      message: "¿Está seguro que desea guardar los cambios de la cotización?",
      icon: "warning",
      func: mutateLicitacion,
    });
  };

  const mutateLicitacion = async () => {
    if (!licitacionHabilitada || loadingMutation) return;
    let productosConCotizaciones = productos.filter((item) => item.cotizaciones?.length > 0);
    let arrayCotizaciones = [];
    productosConCotizaciones?.forEach((item) => {
      item.cotizaciones?.forEach((cotizacion) => {
        arrayCotizaciones.push(cotizacion);
      });
    });
    const input = {
      idPedidoCompra: detalles.id,
      fileUpload: !file?.saved ? file : undefined,
      detalles: arrayCotizaciones.map((cotizacion) => {
        const requierePack = Boolean(cotizacion.requierePack);
        return {
          idMateriaPrima: cotizacion.idMateriaPrima || cotizacion.materiaPrima?.id,
          materiaPrimaAlternativo: requierePack ? false : cotizacion.materiaPrimaAlternativo ? true : false,
          observacion: cotizacion.observacion || null,
          precio: cotizacion.precio,
          idPedidoCompraDetalle: cotizacion.idPedidoCompraDetalle ?? cotizacion.id,
          plazoEntrega: cotizacion.plazoEntrega,
          nombre: cotizacion.nombre || null,
          nombreAlternativo: requierePack ? null : cotizacion.nombreAlternativo || null,
          nombreCompra: cotizacion.nombreCompra || null,
          requierePack: cotizacion.requierePack ?? false,
          unidad: cotizacion.unidad || null,
          unidadPack: cotizacion.unidadPack || null,
        };
      }),
    };

    const id = detalles.cotizaciones?.find((item) => String(item.idProveedor) === String(idProveedor))?.id;

    if (id) {
      input.id = id;
    }

    try {
      const result = await mutate({ variables: { input } });
      if (result.errors?.length || !result.data?.saveCotizacion?.id) return;
      setSelected(null);
      await refetchParent();
    } catch (error) {
      // onError conserva el formulario y muestra el motivo del rechazo.
    }
  };

  const openFile = () => {
    if (file.url) {
      window.open(resolveStoredFileUrl(file.url), "_blank");
    } else {
      const url = URL.createObjectURL(file);
      window.open(url, "_blank");
    }
  };

  return (
    <>
      <SoftButton
        color="dark"
        variant="text"
        sx={{
          cursor: "pointer",
          mb: 2,
        }}
        onClick={() => {
          if (cambiosNoGuardados) {
            confirmar({
              title: "Cambios no guardados",
              message: "Tienes items agregados que no han sido guardados. Si sales ahora, se perderán los cambios.",
              icon: "warning",
              func: () => setSelected(null), // Sale sin guardar
            });
          } else {
            setSelected(null); // Si no hay cambios, vuelve directamente
          }
        }}
        disabled={loadingMutation}
        circular
      >
        <Icon>arrow_back</Icon>&nbsp;Volver
      </SoftButton>
      {rowsAprobados?.length > 0 && (
        <Card
          sx={{
            mb: 2,
          }}
        >
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            flexDirection={{ xs: "column", sm: "row" }}
            gap={1.25}
            p={{ xs: 2, sm: 3 }}
          >
            <SoftTypography variant="h6">Productos ganados</SoftTypography>
            <Tooltip placement="top" title="Reporte PDF">
              <span>
                <SoftButton
                  variant="outlined"
                  color="uproGreen"
                  size="small"
                  onClick={() => window.open(`/op/pdf/${provision?.id ?? 0}`)}
                  sx={{
                    cursor: "pointer",
                    minHeight: 32,
                    px: 1.25,
                    py: 0.65,
                    fontSize: "0.7rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Icon sx={{ fontWeight: "regular", fontSize: "16px !important", mr: 0.55 }}>download</Icon>
                  Descargar OP
                </SoftButton>
              </span>
            </Tooltip>
          </SoftBox>
          <SoftBox>{rowsAprobados?.length > 0 ? <DataTable columns={columnsAprobados} rows={rowsAprobados} /> : <SinDatos />}</SoftBox>
        </Card>
      )}
      <Card>
        <Grid container spacing={2} p={3}>
          <Grid item xs={12}>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" pb={2}>
              <SoftTypography variant="h6">Productos de cotización {detalles.nombre || ""}</SoftTypography>
              <SoftBadge badgeContent={detalles.licitacionEstado} color={colores[detalles.licitacionEstado]} />
            </SoftBox>

            <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap" gap={2}>
              {detalles.responsable && (
                <SoftBox display="flex" flexDirection="column" gap={0.5}>
                  <SoftTypography variant="h6">Consultas técnicas:</SoftTypography>

                  <SoftBox display="flex" alignItems="center" gap={1}>
                    <Icon fontSize="small" sx={{ color: "#344767" }}>
                      person
                    </Icon>
                    <SoftTypography variant="caption" fontWeight="medium" color="dark">
                      {makeNiceText(`${detalles.responsable.nombre} ${detalles.responsable.apellido}`, "nombre")}
                    </SoftTypography>
                  </SoftBox>

                  <SoftBox display="flex" alignItems="center" gap={1}>
                    <Icon fontSize="small" sx={{ color: "#344767" }}>
                      email
                    </Icon>
                    <SoftTypography variant="caption" fontWeight="medium" color="dark" sx={{ overflowWrap: "anywhere" }}>
                      {detalles.responsable.email}
                    </SoftTypography>
                  </SoftBox>

                  <SoftBox display="flex" alignItems="center" gap={1}>
                    <Icon fontSize="small" sx={{ color: "#344767" }}>
                      phone
                    </Icon>
                    <SoftTypography variant="caption" fontWeight="medium" color="dark">
                      {detalles.responsable.telefono || "No disponible"}
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              )}

              <SoftBox display="flex" flexDirection="column" gap={0.5}>
                <SoftTypography variant="h6">Pliegos:</SoftTypography>
                <SoftBox component="a" href={PDFPliego} target="_blank" display="flex" alignItems="center" gap={1}>
                  <Icon fontSize="small" color="error">
                    picture_as_pdf
                  </Icon>
                  <SoftTypography variant="caption" fontWeight="medium" color="dark">
                    General
                  </SoftTypography>
                </SoftBox>
                {/* {pliegos?.particular && (
                  <SoftBox component="a" href={pliegos?.particular} target="_blank" display="flex" alignItems="center" gap={1}>
                    <Icon fontSize="small" color="error">
                      picture_as_pdf
                    </Icon>
                    <SoftTypography variant="caption" fontWeight="medium" color="secondary">
                      Particular
                    </SoftTypography>
                  </SoftBox>
                )} */}
                {/* {pliegos?.solicitud && (
                  <SoftBox component="a" href={pliegos?.solicitud} target="_blank" display="flex" alignItems="center" gap={1}>
                    <Icon fontSize="small" color="error">
                      picture_as_pdf
                    </Icon>
                    <SoftTypography variant="caption" fontWeight="medium" color="secondary">
                      Solicitud
                    </SoftTypography>
                  </SoftBox>
                )} */}
              </SoftBox>
              <SoftBox display="flex" flexDirection="column">
                <SoftTypography variant="h6">Adjuntos:</SoftTypography>
                {adjuntos.length > 0 && (
                  <SoftBox display="flex" flexDirection="column" gap={1} mt={2}>
                    {adjuntos.map((archivo, index) => (
                      <SoftBox
                        key={index}
                        component="a"
                        href={resolveStoredFileUrl(archivo.url)}
                        target="_blank"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        <Icon fontSize="small" color="error">
                          picture_as_pdf
                        </Icon>
                        <SoftTypography variant="caption" fontWeight="medium" color="dark" sx={{ overflowWrap: "anywhere" }}>
                          {archivo.nombre}
                        </SoftTypography>
                      </SoftBox>
                    ))}
                  </SoftBox>
                )}
              </SoftBox>

              <SoftBox display="flex" flexDirection="column" gap={1}>
                <SoftTypography variant="h6">Rubros:</SoftTypography>
                {detalles.categorias?.map((rubro, index) => (
                  <SoftBox key={index} display="flex" flexDirection="column">
                    <SoftTypography variant="caption" color="dark" fontWeight="medium" key={index}>
                      {"- " + rubro.nombre}
                    </SoftTypography>
                  </SoftBox>
                ))}
              </SoftBox>
              {detalles.licitacionFin && (
                <>
                  <SoftBox display="flex" flexDirection="column" gap={1}>
                    <SoftTypography variant="h6">Fecha cierre:</SoftTypography>

                    <SoftTypography variant="caption" color="dark" fontWeight="medium">
                      {dayjs(detalles.licitacionFin).format("DD/MM/YYYY HH:mm")}
                    </SoftTypography>
                  </SoftBox>
                </>
              )}
              {detalles.licitacionFin &&
                (() => {
                  const licitacionFin = dayjs(detalles.licitacionFin);
                  const now = dayjs(); // Verifica si la licitación ya ha cerrado y si están dentro de las 48 horas
                  const hasClosed = now.isAfter(licitacionFin); // Verifica si la fecha actual es posterior a la de cierre
                  const hoursSinceClosure = now.diff(licitacionFin, "hour");
                  const proveedorHaLicitado = detalles?.cotizaciones?.find((cotizacion) => cotizacion.idProveedor === idProveedor);
                  if (hasClosed && hoursSinceClosure <= 48 && proveedorHaLicitado) {
                    return (
                      <SoftBox display="flex" flexDirection="column" gap={1}>
                        <SoftTypography variant="h6">Ranking de Cotizaciones:</SoftTypography>
                        <SoftBox component="a" href={pliegos?.ranking} target="_blank" display="flex" alignItems="center" gap={1}>
                          <Icon fontSize="small" color="error">
                            picture_as_pdf
                          </Icon>
                          <SoftTypography variant="caption" fontWeight="medium" color="dark">
                            Ranking
                          </SoftTypography>
                        </SoftBox>
                      </SoftBox>
                    );
                  }
                  return null;
                })()}
            </SoftBox>
          </Grid>
          <Grid item xs={12} justifyContent="flex-end" display="flex">
            {file ? (
              <Grid display="flex" justifyContent="flex-end" alignItems="center">
                <SoftTypography variant="caption" fontWeight="bold" onClick={openFile} sx={{ cursor: "pointer" }}>
                  {file?.name}
                </SoftTypography>
                {licitacionHabilitada && (
                  <Tooltip title="Quitar archivo">
                    <SoftButton
                      variant="text"
                      color="uproGreen"
                      onClick={() => {
                        setFile(null);
                        setKeyFile(keyFile + 1);
                        setCambiosNoGuardados(true);
                      }}
                      disabled={loadingMutation}
                    >
                      <Icon>cancel</Icon>
                    </SoftButton>
                  </Tooltip>
                )}
              </Grid>
            ) : licitacionHabilitada ? (
              <SoftButton variant="text" color="primary" onClick={toggleInput} disabled={loadingMutation}>
                Adjuntar archivo <Icon>attach_file</Icon>
              </SoftButton>
            ) : null}
          </Grid>
        </Grid>
        <SoftBox>
          {rows?.length > 0 ? (
            <SoftBox px={2}>
              <TableContainer component={Paper} sx={{ overflowX: "hidden", borderRadius: 2 }}>
                <Table
                  aria-label="collapsible table"
                  sx={{
                    width: "100%",
                  }}
                >
                  <TableHead
                    sx={{
                      display: { xs: "none", sm: "table-header-group" },
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ p: 1 }}>
                        <Grid container>
                          <Grid item xs={1} />
                          <Grid item xs={6}>Nombre de compra</Grid>
                          <Grid item xs={2}>Cantidad solicitada</Grid>
                          <Grid item xs={3} />
                        </Grid>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .filter((row) => row.cantidadVerificada > 0)
                      .map((row, index) => (
                        <FilaProducto
                          key={index}
                          row={row}
                          openModal={() => setProductoElegido(row)}
                          setProductoElegido={setProductoElegido}
                          removeLicitacion={removeLicitacion}
                          cotizada={!licitacionHabilitada}
                        />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </SoftBox>
          ) : (
            <SinDatos />
          )}
          <Card
            sx={{
              borderRadius: "0px",
            }}
          >
            <Divider />
            <SoftBox display="flex" flexDirection="row" justifyContent="space-between" p={2}>
              <SoftBox>
                <SoftTypography variant="h6" fontWeight="bold">
                  Total ofertado: ${formatMoneyPunto(total.minimo)}
                  {total.minimo !== total.maximo ? ` a $${formatMoneyPunto(total.maximo)}` : ""}
                </SoftTypography>
                {total.tieneAlternativas && (
                  <SoftTypography variant="caption" color="text">
                    El total depende de la alternativa elegida para cada ítem.
                  </SoftTypography>
                )}
              </SoftBox>
              <Grid display="flex">
                <Grid mr={2}>
                  <SoftButton
                    color="primary"
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      if (cambiosNoGuardados) {
                        confirmar({
                          title: "Cambios no guardados",
                          message: "Tienes productos agregados que no han sido guardados. Si sales ahora, se perderán los cambios.",
                          icon: "warning",
                          func: () => setSelected(null),
                        });
                      } else {
                        setSelected(null);
                      }
                    }}
                    disabled={loadingMutation}
                    circular
                  >
                    <Icon>arrow_back</Icon>&nbsp;Volver
                  </SoftButton>
                </Grid>
                <Grid>
                  {licitacionHabilitada && (
                    <SoftButton
                      variant="gradient"
                      color="dark"
                      sx={{
                        cursor: "pointer",
                      }}
                      onClick={handleSaveLicitacion}
                      circular
                      disabled={!productos.find((item) => item.cotizaciones?.length > 0) || loadingMutation}
                    >
                      <Icon>save</Icon>&nbsp; Guardar cambios
                    </SoftButton>
                  )}
                </Grid>
              </Grid>
            </SoftBox>
          </Card>
        </SoftBox>
        <SoftBox sx={{ display: "none" }}>
          <Input type="file" id="input-file" onChange={handleFile} name="recibos" inputProps={{ multiple: false }} key={keyFile} />
        </SoftBox>
        <ModalLicitacionProducto
          open={Boolean(productoElegido)}
          handleClose={() => setProductoElegido(null)}
          productoElegido={productoElegido}
          handleChangeProducto={handleChangeProducto}
          handleChangeServicio={handleChangeServicio}
          cotizada={false}
          licitacionHabilitada={licitacionHabilitada}
          productoAnterior={productoAnterior}
        />
      </Card>
    </>
  );
}

export default ListadoProductos;

ListadoProductos.propTypes = {
  detalles: PropTypes.object,
  setSelected: PropTypes.func,
  idProveedor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  refetchParent: PropTypes.func,
  colores: PropTypes.object,
};
